
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import XImg from 'vux/src/components/x-img/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import OSD from 'openseadragon'
import Cropper from 'cropperjs'
import PatCaseInfo from './patCaseInfo'
import ScollerView from '../../base/scollerView'
import {eventBus} from '../../../eventbus'
import { _throttle } from '@/utils/public'
const cropWidth = 100
const minZoomFactor = 1 / 400
const maxZoomFactor = 1
const maxSliderHeight = 160
const maxZoom = 400
const minZoom = 1
export default {
components: {OSD, Flexbox, FlexboxItem, XButton, XDialog, XProgress, Box, Popup, Group, Cell, Checker, CheckerItem, Confirm, XTextarea, PatCaseInfo, ScollerView, XImg, Scroller, LoadMore, Spinner},
data () {
return {
$vue: '',
selectSlide: '', // 选中的玻片
selectSample: '', // 选中的样本
iconListOpen: true,

iconLists: [
{fonts: 'icon-personal', name: '患者信息'},
{fonts: 'icon-cell-1', name: '截图信息'},
{fonts: 'icon-screenshot', name: '截图'},
{fonts: 'icon-auscultation', name: '完成诊断'},
{fonts: 'icon-enlarge', name: '放大镜'},
{fonts: 'icon-eye-open', name: '开启/关闭缩略图'},
{fonts: 'icon-enlarge-data', name: '放大倍率'}
],

diagnoseType: this.$route.params.type,

caseType: '',

caseId: this.$route.params.caseid,

slideLayerId: '',

slideLayerTileSource: '',

dnaIndexStandard: 2.5,
diagnoseCropMax: '',
diagnoseCropMin: '',
patCaseInfo: new Map(),
cropList: [],
chooseCropList: [],
pressCropId: '',
pressIndex: '',
showDelCrop: false,
showCrop: true,
showSample: false,

showSampleVer: false,
showCropExplain: false,
cropExplain: '',
viewer: '',
imagingHelper: '',
showNavigator: true,
showZoom: true,
showPerCaseInfo: false,
showBottom: true,
displayZoom: 0,
zoomPercent: 0,
zoomFactor: 0,

cropImgSrc: '',
cropper: '',
showIsCrop: false,
showCancel: false,
tipShow: false,
slideList: [], // 玻片列表
sampleList: [], // 样本列表
scrollTop: 0,
showCell: false,
showCellSign: false,
cellList: [],
loadSign: false,
loadText: '',
limitRange: 20,
limitStart: 0,
showLoad: false
}
},
methods: {

checkSlide (slideLayerId, layeredAddr) {
this.viewer.close()
this.slideLayerId = slideLayerId
this.viewer.open(layeredAddr)

this.getCropList()
},
loadCell () {
if (this.loadSign) {

} else {
this.loadSign = true
if (this.cellList.length >= 20) {
this.limitStart += 20
setTimeout(() => {
this.getCellList()
this.$nextTick(() => {
this.$refs.scrollerCell.reset()
})
this.loadSign = false
}, 2000)
}
}
},

async getCellList () {
let params = new URLSearchParams()
params.append('caseId', this.caseId.toString())
params.append('limit_start', this.limitStart)
params.append('limit_range', this.limitRange)
let suc = await this.$http.post(this.$vue.getData('GET_CELL_LIST_URL'), params)
if (this.cellList.length === 0) {
this.cellList = suc.data.cellList
} else if (suc.data.cellList.length !== 0) {
this.cellList = this.cellList.concat(suc.data.cellList)
}
if (suc.data.cellList.length === 0) {
this.showLoad = false
} else {
this.showLoad = true
}
},

async getSampleList () {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId.toString())
let suc = await this.$http.post(this.$vue.getData('GET_SAMPLE_LIST_URL'), params)
this.sampleList = suc.data.sampleList
this.getSlideList(this.sampleList[0].SAMPLE_ID)
},

async getSlideList (sampleId) {
let params = new URLSearchParams()
params.append('sampleId', sampleId)
let suc = await this.$http.post(this.$vue.getData('GET_SLIDE_LIST_URL'), params)
if (suc.data.result === '1') {
this.slideList = suc.data.data
this.selectSlide = this.slideList[0].SLIDE_ID
this.checkSlide(this.slideList[0].SLIDE_LAYER_ID, this.slideList[0].LAYERED_ADDR)
}
},

close () {
this.iconListOpen = false
},

async casePoolInfo () {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId.toString())
let suc = await this.$http.post(this.$vue.getData('CASE_POOL_CROP_INFO_URL'), params)
if (suc.data.result === '1') {
let data = suc.data.data
this.caseType = data.caseType

let patCase = new Map()
patCase.set('caseName', data.caseName)
patCase.set('patName', data.patName)
patCase.set('patSex', data.patSex)
patCase.set('patAge', data.patAge)
patCase.set('patHologyId', data.patHologyId)
patCase.set('isDifficult', data.isDifficult)
patCase.set('medicalHistory', data.medicalHistory)
patCase.set('clinicalDiagonse', data.clinicalDiagonse)
this.patCaseInfo = patCase

this.dnaIndexStandard = data.diStandard

this.diagnoseCropMax = data.diagnoseCropMax
this.diagnoseCropMin = data.diagnoseCropMin

let slideLayerArray = data.slideLayerInfo
this.slideLayerId = slideLayerArray[0].slideLayerId
this.slideLayerTileSource = slideLayerArray[0].layerAddr

this.selectSample = slideLayerArray[0].SAMPLE_ID
this.selectSlide = slideLayerArray[0].SLIDE_ID

this.getCropList()
this.getSampleList()
if (this.caseType === 1) {
this.showCell = true
this.getCellList()
}
}
},

isShowZoom () {
this.showZoom = !this.showZoom
},

isShowNav () {
this.showNavigator = !this.showNavigator
if (this.showNavigator) {
this.viewer.navigator.element.style.display = 'inline-block'
} else {
this.viewer.navigator.element.style.display = 'none'
}
},

isShowPerCaseInfo () {
this.showPerCaseInfo = !this.showPerCaseInfo
},

isShowCrop () {
this.showCellSign = false
this.showCrop = !this.showCrop
},

isShowCell () {
this.showCrop = false
this.showCellSign = !this.showCellSign
},

isShowSample () {
this.showSample = !this.showSample
this.showCellSign = false
if (this.showSample) {
this.showCrop = false
} else {
this.showCrop = this.cropList.length > 0
}
},
onScroll (pos) {
this.scrollTop = pos.top
},

async getCropList () {

this.chooseCropList = []
let params = new URLSearchParams()
params.append('caseId', this.caseId.toString())
params.append('slideLayerId', this.slideLayerId.toString())
let suc = await this.$http.post(this.$vue.getData('CASE_SAMPLE_CROP_URL'), params)
this.cropList = suc.data.curDoctorCropList
this.addCropSign()


if (this.caseType === 1) {
for (let i = 0; i < this.cropList.length; i++) {
if (this.cropList[i].MARKER === 0 || this.cropList[i].MARKER === 3) {
this.chooseCropList.push(this.cropList[i].CROP_ID)
}
}
} else if (this.caseType === 2) {
for (let i = 0; i < this.cropList.length; i++) {
if (this.cropList[i].IS_CHECK === 1) {
this.chooseCropList.push(this.cropList[i].CROP_ID)
}
}
}

if (!this.showCellSign) {
if (!this.showSample) {
this.showCrop = this.cropList.length > 0
}
}
},

addCropSign () {
this.cropList.forEach(crop => {
let overlay_id = 'overlay_' + crop.CROP_ID
let cropW = crop.WIDTH
let cropH = crop.HEIGHT

let dataX = crop.CREATE_USER === undefined ? crop.STARTX - (cropH / 2) : crop.STARTX
let dataY = crop.CREATE_USER === undefined ? crop.STARTY - (cropW / 2) : crop.STARTY
let diValue = crop.DNAINDEX
let zoom = crop.ZOOMFACTOR

let ele = document.createElement('div')
ele.setAttribute('id', overlay_id)
ele.setAttribute('name', 'crop')
ele.setAttribute('di', diValue)


let logicalX = this.imagingHelper.dataToLogicalX(dataX)
let logicalY = this.imagingHelper.dataToLogicalX(dataY)

let bigger = cropW > cropH ? cropW : cropH
let ratio_w = (bigger / this.imagingHelper.imgWidth) / zoom
let ratio_h = (bigger / this.imagingHelper.imgWidth) / zoom
this.viewer.addOverlay({
element: ele,
location: new OSD.OpenSeadragon.Rect(logicalX, logicalY, ratio_w, ratio_h)
})
})
},

addRedGreenSign: _throttle((dnaIndexStandard) => {
let crops = document.getElementsByName('crop')
crops.forEach(e => {
e.setAttribute('class', 'icon-location')
e.style.color = parseFloat(e.getAttribute('di')) > dnaIndexStandard ? 'red' : 'green'
})
}, 1000),
addSqBoxSign: _throttle(() => {
let crops = document.getElementsByName('crop')
crops.forEach(e => {
e.setAttribute('class', 'sq-box')
e.style.color = 'none'
})
}, 1000),

checkCrop (crop) {


let isCheck = this.chooseCropList.indexOf(crop.CROP_ID) === -1 ? 1 : 0

if (isCheck === 1 && (this.chooseCropList.length >= this.diagnoseCropMax)) {
return
}
let url
let params = new URLSearchParams()
params.append('CROP_ID', crop.CROP_ID)
params.append('IS_CHECK', isCheck.toString())

if (this.caseType === 1) {
params.append('CASE_ID', this.caseId.toString())
url = this.$vue.getData('CHOSEN_CELL_CROP_URL')
} else if (this.caseType === 2) {

url = this.$vue.getData('CHOSEN_TISSUE_CROP_URL')
}

this.$http.post(url, params)
},

isShowExtraMenu (cropId, cropIndex) {
this.pressCropId = cropId
this.pressIndex = cropIndex
},

jumpToCropLocation (crop) {

let x = this.imagingHelper.dataToLogicalX(crop.STARTX)
let y = this.imagingHelper.dataToLogicalY(crop.STARTY)
let zoom = crop.ZOOMFACTOR
this.imagingHelper.centerAboutLogicalPoint(this.imagingHelper.getOSDPoint(x, y), false)
this.imagingHelper.setZoomFactor(zoom, true)

if (this.pressCropId !== crop.CROP_ID) {
this.pressCropId = -1
}

event.stopPropagation()
},

jumpToCropLocationCell (crop) {
if (crop.LAYER_ID !== this.slideLayerId) {
this.checkSlide(crop.LAYER_ID, crop.LAYERED_ADDR)
const that = this
setTimeout(function () {

let x = that.imagingHelper.dataToLogicalX(crop.CELL_START_X)
let y = that.imagingHelper.dataToLogicalY(crop.CELL_START_Y)
let zoom = 1.0
that.imagingHelper.centerAboutLogicalPoint(that.imagingHelper.getOSDPoint(x, y), false)
that.imagingHelper.setZoomFactor(zoom, true)

event.stopPropagation()
}, 2000)
} else {
this.cellJumpToCrop(crop)
}
},
cellJumpToCrop (crop) {

let x = this.imagingHelper.dataToLogicalX(crop.CELL_START_X)
let y = this.imagingHelper.dataToLogicalY(crop.CELL_START_Y)
let zoom = 1.0
this.imagingHelper.centerAboutLogicalPoint(this.imagingHelper.getOSDPoint(x, y), false)
this.imagingHelper.setZoomFactor(zoom, true)

event.stopPropagation()
},

delCrop () {
let params = new URLSearchParams()
params.append('CROP_ID', this.pressCropId.toString())
this.$http.post(this.$vue.getData('IS_DELETE_CROP'), params).then(suc => {
if (suc.data === 'success') {

this.viewer.removeOverlay(document.getElementById('overlay_' + this.pressCropId.toString()))

this.cropList.splice(this.pressIndex, 1)
}
}, err => {
console.log(err)
})
},

isShowCropExplain () {
this.showCropExplain = !this.showCropExplain
if (this.showCropExplain) {
this.cropExplain = this.cropList[this.pressIndex].DETAIL_INFO
}

event.stopPropagation()
},

isShowDelCrop () {
this.showDelCrop = true

event.stopPropagation()
},

updateCropExplain () {
let params = new URLSearchParams()
params.append('cropId', this.pressCropId.toString())
params.append('crop.detailInfo', this.cropExplain.toString())
this.$http.post(this.$vue.getData('UPDATE_CROP_INFO_URL'), params).then(suc => {

this.cropList[this.pressIndex].DETAIL_INFO = this.cropExplain.toString()
this.showCropExplain = false
}, err => {
console.log(err)
})

this.pressCropId = -1
},
onImageViewChanged () {

this.zoomFactor = this.imagingHelper.getZoomFactor()
},

crop () {
this.cropImgSrc = this.viewer.drawer.canvas.toDataURL('image/jpeg')
},

getCropCanvasInfo (sourceCanvas) {
let params = new URLSearchParams()
let cropCanvas = this.cropper.getData()

let cropImageData = this.cropper.getImageData()
let ratio = cropImageData.width / cropImageData.naturalWidth
let x = cropCanvas.x * ratio
let y = cropCanvas.y * ratio
let trueX = parseInt(this.imagingHelper.physicalToDataX(x))
let trueY = parseInt(this.imagingHelper.physicalToDataY(y))

let w = (cropCanvas.width * ratio).toFixed(0)
let h = (cropCanvas.height * ratio).toFixed(0)

let cropImgData = sourceCanvas.toDataURL('image/jpeg').split(',')[1]

params.append('caseId', this.caseId)
params.append('slideLayerId', this.slideLayerId)
params.append('cropImgData', cropImgData)
params.append('crop.height', h)
params.append('crop.width', w)
params.append('crop.picType', '2')
params.append('crop.dnaindex', '0')
params.append('crop.startX', trueX)
params.append('crop.startY', trueY)
params.append('crop.zoomFactor', this.zoomFactor)
return params
},

cropCancel () {
this.showIsCrop = false
this.cropImgSrc = ''
},

cropConfirm () {

eventBus.$emit('showLoading', true, '上传中')
let canvas = this.cropper.getCroppedCanvas()
let params = this.getCropCanvasInfo(canvas)
this.$http.post(this.$vue.getData('UPLOAD_CROP_URL'), params).then(suc => {

this.showIsCrop = false

this.getCropList()
eventBus.$emit('showLoading', false)
}, err => {
console.log(err)
})
this.cropImgSrc = ''
},

async finishDiagnosis () {
if (this.caseType === 1) {

this.$router.push({ path: '/cellreportedit/0/' + this.caseId + '/ /' })
} else {

if (this.chooseCropList.length >= this.diagnoseCropMin && this.chooseCropList.length <= this.diagnoseCropMax) {

this.$router.push({ path: '/tissuereportedit/0/' + this.caseId + '/ /' })
} else {
AlertModule.show({
content: '报告需要选择' + this.diagnoseCropMin + '-' + this.diagnoseCropMax + '张图片，当前选择' + this.chooseCropList.length + '张。'
})
}
}
},

async cancelDiagnose () {
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('DIAGNOSE_TYPE', this.diagnoseType)
let suc = await this.$http.post(this.$vue.getData('CANCEL_DIAGNOSE'), params)
if (suc.data.result === '1') {

if (this.diagnoseType === '3' || this.diagnoseType === '4' || this.diagnoseType === '5') {
this.$router.push({name: 'YzdCaseList'})
} else {

this.$router.go(-1)
}
}
},
clickImg (cropId) {











event.stopPropagation()
}
},
computed: {

computeScrollWidth: function () {
return this.cropList.length * cropWidth + 'px'
},
computeScrollWidthCell: function () {
return this.cellList.length * cropWidth + 'px'
},

computeSampleScrollWidth: function () {
return this.sampleList.length * 105 + 'px'
},

computeSlideScrollWidth: function () {
return this.slideList.length * 100 + 'px'
},

computeSlideScrollHeight: function () {
return this.slideList.length * 40 + 'px'
},

computeCellHeight: function () {
return this.cellList.length * 74 + 'px'
}
},
watch: {

slideLayerTileSource (val, oldval) {

this.viewer = OSD.OpenSeadragon({
id: 'viewer', // 指定显示的div
crossOriginPolicy: 'anonymous', // 设置支持跨域
tileSources: this.slideLayerTileSource,
visibilityRatio: 1, // 图片在框内的最小比例
minZoomImageRatio: 1,
constrainDuringPan: true, // 禁止拽出范围
maxZoomPixelRatio: 1, // 图片的最大缩放比
zoomInButton: 'zinbtn', // 放大
zoomOutButton: 'zoutbtn', // 缩小
homeButton: 'homebtn', // 恢复默认
fullPageButton: 'fullpagebtn', // 全屏
showNavigator: true,
navigatorAutoFade: false, // 禁用自动隐藏导航视图
navigatorPosition: 'ABSOLUTE',
navigatorTop: '5px',
navigatorHeight: '110px',
navigatorWidth: '110px',
navigatorBorderColor: '#f56100'
})

this.imagingHelper = this.viewer.activateImagingHelper({onImageViewChanged: this.onImageViewChanged})

this.viewer.scalebar({
type: OSD.OpenSeadragon.ScalebarType.MICROSCOPY,
pixelsPerMeter: 3700000,
minWidth: 70,
location: OSD.OpenSeadragon.ScalebarLocation.BOTTOM_LEFT,
xOffset: 5,
yOffset: 60,
stayInsideImage: true,
color: 'rgb(150, 150, 150)',
fontColor: 'rgb(100, 100, 100)',
backgroundColor: 'rgba(255, 255, 255, 0.5)',
fontSize: 'small',
barThickness: 2
})
},
zoomFactor (val, oldval) {


let k = maxSliderHeight / (maxZoomFactor - minZoomFactor)
let zoom = k * this.zoomFactor + -k * minZoomFactor
let j = (maxZoom - minZoom) / maxSliderHeight
this.displayZoom = (j * zoom + minZoom).toFixed(0)
this.zoomPercent = this.displayZoom / maxZoom * 100

if (val < 0.5) {
this.addRedGreenSign(this.dnaIndexStandard)
} else {
this.addSqBoxSign()
}
},
cropImgSrc (val, oldval) {

if (this.cropper) {
this.cropper.replace(this.cropImgSrc)
}
if (val !== '') {
this.showIsCrop = true
}
},

cropList (val, oldVal) {
if (this.zoomFactor < 0.5) {
this.addRedGreenSign(this.dnaIndexStandard)
} else {
this.addSqBoxSign()
}
}
},
mounted () {

let image = document.getElementById('cropImage')
this.$nextTick(() => {
this.$refs.scrollerEvent.reset({top: 0})
})
this.cropper = new Cropper(image, {
aspectRatio: 1,
viewMode: 1,
background: false,
guides: false, // 截图框线条
center: false, // 中心十字架
zoomable: false
})

eventBus.$emit('showLoading', false)
},
beforeMount () {
this.$vue = this

this.casePoolInfo()

this.$wechat.miniProgram.getEnv(function (res) {
if (res.miniprogram) {
console.log(res.miniprogram)

let link = document.createElement('link')
link.setAttribute('rel', 'stylesheet')
link.setAttribute('type', 'text/css')
link.setAttribute('href', '../../../static/css/mini.css')
window.document.head.appendChild(link)
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/diagnosis/diagnosis.vue